module.exports = __webpack_public_path__ + "img/leaf-word.804c91ed.png";